/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ImgUploadComponent.vue?vue&type=template&id=5c437f6d&scoped=true&"
import script from "./ImgUploadComponent.vue?vue&type=script&lang=js&"
export * from "./ImgUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploadComponent.vue?vue&type=style&index=0&id=5c437f6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c437f6d",
  null
  
)

export default component.exports